// ── Polyfills (першими — до будь-якого React коду) ───────────────────
import './ErrorLogger'; // ← глобальний перехоплювач помилок

import React from 'react';
import { createRoot } from 'react-dom/client';
import "./scss/style.scss";
import { Provider } from 'react-redux';
import App from './App';
import store from './store';
import { ThemeProvider } from './context/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary';

// ── Cache migration ───────────────────────────────────────────────────
const APP_VERSION = '2.0';
const STORED_VERSION = (() => { try { return localStorage.getItem('bv_app_ver'); } catch { return null; } })();

if (STORED_VERSION !== APP_VERSION) {
  const STALE_KEYS = [
    'bv_products_cache', 'bv_products_ver',
    'profileCache', 'profileCacheTs', 'profileBadge',
    'bv_settings', 'bv_cart_organic',
    'bv_seen_inv', 'bv_seen_cust', 'bv_seen_dbg_ts',
    'adm_tab_config', 'bv_sql_config',
  ];
  try {
    STALE_KEYS.forEach(k => localStorage.removeItem(k));
    localStorage.setItem('bv_app_ver', APP_VERSION);
  } catch {}
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <ThemeProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </ThemeProvider>
  </ErrorBoundary>
);
